import vue from 'vue'
import App from './App.vue'
import axios from 'axios';
import './assets/iconfont/iconfont.js'
import plugins from './components/index';
//import formDesigner from './index'
import router from '@/router'
import "vant/lib/image-preview/style/index";

import { loadAjax, successAjax } from '@/tools/Ajax';
import { getToken } from '@/tools/token';
import ValueRender from "./pages/view_form_data/ValueRender";
import Print from '@/tools/print';

Vue.prototype.$loadAjax = loadAjax; //带有加载状态的ajax
Vue.prototype.$successAjax = successAjax; //成功加载
Vue.prototype.$getToken = getToken; //获取tok

vue.config.productionTip = false;
// Vue.config.devtools = true;
Vue.prototype.$axios = axios
vue.use(plugins);
vue.use(ValueRender);
Vue.use(Print) // 注册
// console.log(Print)

import "./style/base.scss";
import "./style/reset.scss";

new vue({
  router,
  render: h => h(App)
}).$mount('#app')
